import React, { useEffect } from 'react'
import classNames from 'classnames'
import { ControlProps, getControlParts } from './Control'
import { useIMask } from 'react-imask';

export interface InputProps extends ControlProps {
	value: string
	onChange: (value: string) => void
	mask?: string
}

export function Input(props: InputProps) {

	const mask = props.mask || ''
	const iMask = useIMask({ mask }) 

	// feels like a hack.  TODO: find out how to set initial mask values
	useEffect(() => {
		if (props.value != iMask.value) iMask.setUnmaskedValue(props.value || '')
	}, [props.value, props.mask])

	let inputClass = classNames('input', { 'is-danger': props.errorMessage }, props.size && `is-${props.size}`)

	const controlProps = getControlParts(props)

	const changeHandler: React.ChangeEventHandler<HTMLInputElement> = (e) => {
		props.onChange(props.mask ? iMask.unmaskedValue : e.target.value)
	}

	const inputProps: { value?: string, ref?: React.LegacyRef<HTMLInputElement> } = {
		ref: props.mask ? iMask.ref as React.LegacyRef<HTMLInputElement> : undefined, 
		value: props.mask ? undefined : props.value
	}

	const inputControl = (
		<div className='input-component field'>
			{controlProps.labelElement}
			<div className='control'>
				<input {...inputProps} id={controlProps.inputId} className={inputClass} type='text' onChange={changeHandler} disabled={props.disabled} />
			</div>
			{controlProps.helpTextElement}
		</div>
	)

	return props.isInColumn ? <div className='column'>{inputControl}</div> : inputControl
}

export default Input

